import request, { DefaultResponseData } from '@utils/request';

export interface GetInviteContentReq {
  sub_meeting_id: string;
  meeting_id: string;
  ability: number;
  is_share_page: number;
  language: string;
}

// 获取用户信息
export async function getInviteContent(params: GetInviteContentReq): Promise<DefaultResponseData<string>> {
  return await request({
    url: '/wemeet/manage_service_not_auth/comm/v1/query_invite_content',
    data: params,
    type: 'POST',
    prefixType: 'webtapi',
  });
}

/**
 * @description 查看是否合规
 */
export async function checkServiceAgreementApprove(params: {
  device_id: string;
  lawful_type: 'guest_join';
  meeting_code: string;
}): Promise<DefaultResponseData<{ need_check_lawful: boolean }>> {
  return await request({
    url: '/v2/lawful/process/check-service-agreement-approve',
    data: params,
    type: 'POST',
  });
}
